import { useTranslation } from 'react-i18next';
import OpenIcon from 'assets/img/icons/box-arrow-up-right.svg?react';
import { Routes } from 'router/routes';
import { useNavigate } from 'react-router-dom';

import s from './styles.module.scss';

import type { IClinicCareManagerLite } from 'infrastructure/interfaces';
import type { IBaseTableColumnProps } from 'components/atoms/base-table/types';

interface IProps {
  disableRefs?: boolean;
}

export const useCols = ({ disableRefs }: IProps) => {
  const { t } = useTranslation();
  const navigation = useNavigate();
  const cols: IBaseTableColumnProps<IClinicCareManagerLite>[] = [
    {
      label: t('labels.user'),
      key: 'firstName',
      width: '100%',
      render(val, record) {
        return (
          <div className={s['name-wrapper-editable']}>
            <button
              className={s['navigation-wrapper']}
              style={{ cursor: disableRefs ? 'default' : 'pointer' }}
              onClick={() => {
                if (!disableRefs) {
                  navigation(Routes.adminAgencyDoctor(record.doctorGuid));
                }
              }}
            >
              <OpenIcon width={16} height={16} />
            </button>
            <p className={s['text-bold']}>
              {record.firstName} {record.lastName}
            </p>
          </div>
        );
      },
    },
  ];

  return { cols };
};
